/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MediaUpload = {
    properties: {
        id: {
            type: 'string',
            isRequired: true,
        },
        url: {
            type: 'string',
            isRequired: true,
        },
        aspectRatio: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
